<template>
  <div class="kpichart">
    <div class="kpi-percentage">
      <span class="kpi-left">
        {{percentage}}%
      </span>
      <span class="kpi-right">
        {{100 - percentage}}%
      </span>
    </div>
    <div class="kpi-container">
      <div class="kpi-bar" :style="percentageStyle">
      </div>
    </div>
    <div class="kpi-label">
      <div class="kpi-label-left">
        <span>{{leftlabel}}</span>
      </div>
      <div class="kpi-label-right">
        <span>{{rightlabel}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    values: {
      type: Object,
    },
    labels: {
      type: Object,
    },
  },
  computed: {
    percentageStyle() {
      return `width: ${this.percentage}%`;
    },
    percentage() {
      return this.values.x_percentile;
    },
    leftlabel() {
      return this.labels.x_percentile;
    },
    rightlabel() {
      return this.labels.y_percentile;
    },
  },
};
</script>
<style lang="scss">
.kpichart {
  margin-bottom: 25px;
}
.kpi-container {
  // width: 400px;
  height: 10px;
  // margin-top: 20px;
  // margin-bottom: 20px;
  background-color: #E8655D;
}
.kpi-bar {
  // width: 50%;
  display: inline-block;
  height: 100%;
  background-color: #D5E3FF;
  transition: width 2s;
}
.kpi {
  &-percentage {
    padding-top: 5px;
    padding-bottom: 5px;
    span {
      display: inline-block;
      color: #CADCFF;
      font-size: 18px;
    }
  }
  &-left {

  }
  &-right {
    float: right;
  }
  &-label {
    padding-top: 10px;
    overflow: auto;
    &-left {
      float: left;
    }
    &-right {
      float: right;
      text-align: right;
    }
    span {
      display: block;
      margin-top: 3px;
      color: #6D8EB4;
      font-size: 14px;
    }
  }
}
</style>
